module.exports = __webpack_public_path__ + "e5de155bf4bb6e3787498b6ee752bb48.svg";